import {EventWizardProgressStep, orderedProgressSteps} from '@Components/event-wizard/event-wizard.types';
import {GA4EventName} from '@Libraries/ga-events';

export const isEventWizardFirstStep = (currentStep: EventWizardProgressStep): boolean => {
  return currentStep === orderedProgressSteps[0];
};

/**
 * The GA4 event for the Next click that LEAVES each step. Event names state the step being ENTERED,
 * so leaving OVERVIEW reports Step2. REVIEW creates the event instead of advancing, so it reports
 * nothing.
 */
export const GA4_EVENT_ON_LEAVING_STEP: Record<EventWizardProgressStep, GA4EventName | null> = {
  [EventWizardProgressStep.OVERVIEW]: GA4EventName.EVENT_WIZARD_COMPLETE_FIRST_STEP,
  [EventWizardProgressStep.TICKETING]: GA4EventName.EVENT_WIZARD_COMPLETE_SECOND_STEP,
  [EventWizardProgressStep.REVIEW]: null,
};
